/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import produce from "immer";
import {
  GET_RETURN_PACKAGES_REQUEST,
  GET_RETURN_PACKAGES_SUCCESS,
  GET_RETURN_PACKAGES_FAILURE,
  SEARCH_REQUEST,
  SEARCH_SUCCESS,
  SEARCH_FAILURE,
  UPDATE_RETURN_PACKAGE_REQUEST,
  UPDATE_RETURN_PACKAGE_SUCCESS,
  UPDATE_RETURN_PACKAGE_FAILURE
} from "src/actions/packageActions";
import _ from "lodash";

const initialState = {
  packages: [],
  package: {},
  returnPackage: {},
  returnPackages: [],
  total: 0,
  loading: false
};

const packageReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_RETURN_PACKAGES_REQUEST: {
      return produce(state, (draft) => {
        draft.returnPackages = [];
        draft.loading = true;
      });
    }

    case GET_RETURN_PACKAGES_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.returnPackages = response;
        draft.loading = false;
      });
    }

    case GET_RETURN_PACKAGES_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case SEARCH_REQUEST: {
      return produce(state, (draft) => {
        draft.returnPackages = [];
        draft.loading = true;
      });
    }

    case SEARCH_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.returnPackages = response;
        draft.loading = false;
        draft.total = total;
      });
    }

    case SEARCH_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case UPDATE_RETURN_PACKAGE_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case UPDATE_RETURN_PACKAGE_SUCCESS: {
      const {response} = action.payload;
      const newReturnPackages = _.map(state.returnPackages, (i) => {
        if (i.id === response.id) return response;
        return i;
      });
      return produce(state, (draft) => {
        draft.returnPackages = newReturnPackages;
        draft.loading = false;
      });
    }

    case UPDATE_RETURN_PACKAGE_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default packageReducer;
